export default {
    ads: {
        'click': 'Kliknij w reklamę',
        'click-empty': 'Kliknij w miejsce na reklamę'
    },
    chat: {
        close: 'Zamknij czat',
        open: 'Otwórz czat',
        send: 'Wyślij wiadomość',
        spam: 'Spam na czacie'
    },
    player: {
        mute: 'Wycisz odtwarzacz',
        play: 'Włącz odtwarzacz',
        stop: 'Wyłącz odtwarzacz',
        unmute: 'Anuluj wyciszenie',
        volume: 'Zmień głośność'
    }
}
